export const fetchOverview = async (request, city, year) => {
    try {
        const res = await request(
            "GET",
            `/v1/city-profile/overview?location=${city}&year=${year}`,
            {},
            "survey_service"
        );
        return res;
    } catch (err) {
        console.error(err);
    }
};
export const fetchInfrastructure = async (request, city, year) => {
    try {
        const res = await request(
            "GET",
            `/v1/city-profile/infrastructure?location=${city}&year=${year}`,
            {},
            "survey_service"
        );
        return res;
    } catch (err) {
        console.error(err);
    }
};
export const fetchInstitutionalCapacity = async (request, city, year) => {
    try {
        const res = await request(
            "GET",
            `/v1/city-profile/institutional_capacity?location=${city}&year=${year}`,
            {},
            "survey_service"
        );
        return res;
    } catch (err) {
        console.error(err);
    }
};
export const fetchIndicators = async (request, city, year) => {
    try {
        const res = await request(
            "GET",
            `/v1/city-profile/indicators?location=${city}&year=${year}`,
            {},
             "survey_service"
        );
        return res;
    } catch (err) {
        console.error(err);
    }
};






export const fetchSludgeImage = async (request, city, year) => {
    // Placeholder: In real scenario, fetch from API
    return "https://i.imgur.com/B10DRoY.png";
};


export const fetchCityName = async (request,id) => {

    try {
        const response = await request(
            "GET",
            `/v1/survey/locations/city-profile`,
            {},
            "survey_service"
        );
        const city = response.find(c => c.id === id);
       if (!city) return null;

    return {
        city_name: `${city.name} ${city.type === "CITY_CORPORATION" ? "City Corporation" : "Municipality"}`
    };

    } catch (error) {
        console.log(error);
    }
    
};

const cities = [
        {
        "id": 1309,
        "name": "Barishal",
        "type": "CITY_CORPORATION"
    },
    {
        "id": 1306,
        "name": "Bagerhat",
        "type": "MUNICIPALITY"
    },
    {
        "id": 1307,
        "name": "Bandarban",
        "type": "MUNICIPALITY"
    },
    {
        "id": 1308,
        "name": "Barguna",
        "type": "MUNICIPALITY"
    },

    {
        "id": 1310,
        "name": "Bhola",
        "type": "MUNICIPALITY"
    },
    {
        "id": 1311,
        "name": "Bogura",
        "type": "MUNICIPALITY"
    },
    {
        "id": 1312,
        "name": "Brahmanbaria",
        "type": "MUNICIPALITY"
    },
    {
        "id": 1313,
        "name": "Chandpur",
        "type": "MUNICIPALITY"
    },
    {
        "id": 1314,
        "name": "Chapai Nawabganj",
        "type": "MUNICIPALITY"
    },
    {
        "id": 1316,
        "name": "Chuadanga",
        "type": "MUNICIPALITY"
    },
    {
        "id": 1369,
        "name": "Cox's Bazar",
        "type": "MUNICIPALITY"
    },
    {
        "id": 1317,
        "name": "Cumilla",
        "type": "MUNICIPALITY"
    },
    {
        "id": 1318,
        "name": "Dinajpur",
        "type": "MUNICIPALITY"
    },
    {
        "id": 1319,
        "name": "Faridpur",
        "type": "MUNICIPALITY"
    },
    {
        "id": 1320,
        "name": "Feni",
        "type": "MUNICIPALITY"
    },
    {
        "id": 1321,
        "name": "Gaibandha",
        "type": "MUNICIPALITY"
    },
    {
        "id": 1323,
        "name": "Gazipur",
        "type": "CITY_CORPORATION"
    },
    {
        "id": 1324,
        "name": "Gopalganj",
        "type": "MUNICIPALITY"
    },
    {
        "id": 1325,
        "name": "Habiganj",
        "type": "MUNICIPALITY"
    },
    {
        "id": 1326,
        "name": "Jamalpur",
        "type": "MUNICIPALITY"
    },
    {
        "id": 1327,
        "name": "Jashore",
        "type": "MUNICIPALITY"
    },
    {
        "id": 1328,
        "name": "Jhalokathi",
        "type": "MUNICIPALITY"
    },
    {
        "id": 1329,
        "name": "Jhenaidah",
        "type": "MUNICIPALITY"
    },
    {
        "id": 1330,
        "name": "Joypurhat",
        "type": "MUNICIPALITY"
    },
    {
        "id": 1331,
        "name": "Khagrachhari",
        "type": "MUNICIPALITY"
    },
    {
        "id": 1332,
        "name": "Kishoreganj",
        "type": "MUNICIPALITY"
    },
    {
        "id": 1333,
        "name": "Kurigram",
        "type": "MUNICIPALITY"
    },
    {
        "id": 1334,
        "name": "Kushtia",
        "type": "MUNICIPALITY"
    },
    {
        "id": 1335,
        "name": "Lakshmipur",
        "type": "MUNICIPALITY"
    },
    {
        "id": 1336,
        "name": "Lalmonirhat",
        "type": "MUNICIPALITY"
    },
    {
        "id": 1337,
        "name": "Madaripur",
        "type": "MUNICIPALITY"
    },
    {
        "id": 1338,
        "name": "Magura",
        "type": "MUNICIPALITY"
    },
    {
        "id": 1339,
        "name": "Manikganj",
        "type": "MUNICIPALITY"
    },
    {
        "id": 1340,
        "name": "Meherpur",
        "type": "MUNICIPALITY"
    },
    {
        "id": 1341,
        "name": "Moulvibazar",
        "type": "MUNICIPALITY"
    },
    {
        "id": 1342,
        "name": "Munshiganj",
        "type": "MUNICIPALITY"
    },
    {
        "id": 1343,
        "name": "Mymensingh",
        "type": "CITY_CORPORATION"
    },
    {
        "id": 1345,
        "name": "Naogaon",
        "type": "MUNICIPALITY"
    },
    {
        "id": 1346,
        "name": "Narail",
        "type": "MUNICIPALITY"
    },
    {
        "id": 1347,
        "name": "Narayanganj",
        "type": "CITY_CORPORATION"
    },
    {
        "id": 1348,
        "name": "Narsingdi",
        "type": "MUNICIPALITY"
    },
    {
        "id": 1349,
        "name": "Natore",
        "type": "MUNICIPALITY"
    },
    {
        "id": 1350,
        "name": "Netrokona",
        "type": "MUNICIPALITY"
    },
    {
        "id": 1351,
        "name": "Nilphamari",
        "type": "MUNICIPALITY"
    },
    {
        "id": 1352,
        "name": "Noakhali",
        "type": "MUNICIPALITY"
    },
    {
        "id": 1353,
        "name": "Pabna",
        "type": "MUNICIPALITY"
    },
    {
        "id": 1354,
        "name": "Panchagarh",
        "type": "MUNICIPALITY"
    },
    {
        "id": 1355,
        "name": "Patuakhali",
        "type": "MUNICIPALITY"
    },
    {
        "id": 1356,
        "name": "Pirojpur",
        "type": "MUNICIPALITY"
    },
    {
        "id": 1357,
        "name": "Rajbari",
        "type": "MUNICIPALITY"
    },
    {
        "id": 1358,
        "name": "Rajshahi",
        "type": "CITY_CORPORATION"
    },
    {
        "id": 1359,
        "name": "Rangamati",
        "type": "MUNICIPALITY"
    },
    {
        "id": 1361,
        "name": "Rangpur",
        "type": "CITY_CORPORATION"
    },
    {
        "id": 1362,
        "name": "Satkhira",
        "type": "MUNICIPALITY"
    },
    {
        "id": 1363,
        "name": "Shariatpur",
        "type": "MUNICIPALITY"
    },
    {
        "id": 658,
        "name": "Sherpur",
        "type": "MUNICIPALITY"
    },
    {
        "id": 1364,
        "name": "Sirajganj",
        "type": "MUNICIPALITY"
    },
    {
        "id": 1365,
        "name": "Sunamganj",
        "type": "MUNICIPALITY"
    },
    {
        "id": 1366,
        "name": "Sylhet",
        "type": "CITY_CORPORATION"
    },
    {
        "id": 1367,
        "name": "Tangail",
        "type": "MUNICIPALITY"
    },
    {
        "id": 1368,
        "name": "Thakurgaon",
        "type": "MUNICIPALITY"
    },




  {
        "id": 1415,
        "name": "Alamdanga",
        "type": "MUNICIPALITY"
    }, {
        "id": 1406,
        "name": "Ajmiriganj",
        "type": "MUNICIPALITY"
    }, {
        "id": 1424,
        "name": "Basurhat",
        "type": "MUNICIPALITY"
    }, {
        "id": 1433,
        "name": "Belkuchi",
        "type": "MUNICIPALITY"
    }, {
        "id": 1397,
        "name": "Benapole",
        "type": "MUNICIPALITY"
    }, {
        "id": 1442,
        "name": "Boalmari",
        "type": "MUNICIPALITY"
    }, {
        "id": 1451,
        "name": "Shibganj",
        "type": "MUNICIPALITY"
    },
]